import React, { useState, useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import { Redirect } from "react-router-dom";
import Spinner from "../common/Spinner";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappIcon,
  WhatsappShareButton,
  TelegramShareButton,
  TelegramIcon,
  LinkedinShareButton,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";

const GET_POSTS = gql`
  {
    posts {
      title
      slug
      coverImage {
        url
      }
      url
    }
  }
`;

const GET_POST = gql`
  query GetPost($path: String!) {
    posts(where: { url: $path }) {
      title
      slug
      coverImage {
        url
      }
      content {
        html
      }
      siteTitle
      siteDescription
      url
    }
  }
`;

function renderPost(post, isMobile, setVariables) {
  if (post) {
    setVariables({
      blogTitle: post.title,
      siteTitle: post.siteTitle,
      siteDescription: post.siteDescription,
      url: `https://www.jetminds.de${post.url}`,
    });
    return (
      <React.Fragment>
        <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"} blog`}>
          {post.slug}
        </h1>
        <div className="section">
          <div className="row">
            <div className="col s12 m12">
              <img
                className="responsive-img"
                src={post.coverImage.url}
                alt={`JetMinds ${post.title}`}
              />
            </div>
            <div
              className="col s12 m12"
              dangerouslySetInnerHTML={{ __html: post.content.html }}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function renderReadMore(posts) {
  return posts.map((item) => {
    return (
      <div key={item.url} className="col s12 m12">
        <div className="card">
          <div className="card-image">
            <a href={item.url}>
              <img
                className="activator"
                src={item.coverImage.url}
                alt={item.slug}
                loading="lazy"
              />{" "}
            </a>
          </div>
          <div className="card-content">
            <p>{item.title}</p>
          </div>
        </div>
      </div>
    );
  });
}

function GetPosts(props) {
  const [posts, setPosts] = useState([]);
  const [allPosts, setAllPosts] = useState([]);
  const [loaded, setloaded] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);
  const { loading, error, data } = useQuery(GET_POST, {
    variables: { path: props.path },
  });
  const loadingAllPosts = useQuery(GET_POSTS).loading;
  const errorAllPosts = useQuery(GET_POSTS).error;
  const dataAllPosts = useQuery(GET_POSTS).data;

  useEffect(() => {
    const fetchPost = () => {
      const fetchedPost = data;
      if (data) {
        setPosts(fetchedPost.posts);
        setloaded(true);
      }
    };
    const fetchPosts = () => {
      const fetchedPosts = dataAllPosts;
      if (dataAllPosts) {
        let newPosts = [];
        if (fetchedPosts.posts.length <= 3) {
          newPosts = fetchedPosts.posts;
        } else if (data) {
          while (newPosts.length < 3) {
            const randomPost =
              fetchedPosts.posts[
                Math.floor(Math.random() * fetchedPosts.posts.length)
              ];
            if (
              newPosts.indexOf(randomPost) === -1 &&
              randomPost.url !== data.posts[0].url
            ) {
              newPosts.push(randomPost);
            }
          }
        }
        setAllPosts(newPosts);
        setAllLoaded(true);
      }
    };
    fetchPost();
    fetchPosts();
  }, [data, dataAllPosts]);

  if (loading || loadingAllPosts) return <Spinner />;
  if (error || errorAllPosts) return <p>Ein Fehler ist aufgetreten :(</p>;
  return (
    <div className="container">
      <div className="section">
        {props.isMobile || props.isTablet ? (
          <div className="row">
            <div className="col s12 m12">
              {loaded && posts.length === 0 && allLoaded ? (
                <Redirect to="/blog" />
              ) : (
                renderPost(posts[0], props.isMobile, props.setVariables)
              )}
            </div>
            <div className="col s12 m12 center">
              <h5>Artikel teilen</h5>
            </div>
            {posts[0] ? (
              <div className="col s12 m12 center">
                <FacebookShareButton
                  quote={`${posts[0].title}${"\n"}${posts[0].siteDescription}`}
                  url={`https://www.jetminds.de${posts[0].url}`}
                  style={{ padding: 3 }}
                >
                  <FacebookIcon round size={40} />
                </FacebookShareButton>
                <TwitterShareButton
                  title={`${posts[0].title}${"\n"}${
                    posts[0].siteDescription
                  }${"\n"}`}
                  via="JetMinds_de"
                  related={["JetMinds_de"]}
                  style={{ padding: 3 }}
                  url={`https://www.jetminds.de${posts[0].url}`}
                >
                  <TwitterIcon round size={40} />
                </TwitterShareButton>
                <LinkedinShareButton
                  title={`${posts[0].title}`}
                  summary={`${posts[0].siteDescription}`}
                  style={{ padding: 3 }}
                  source={`https://www.jetminds.de${posts[0].url}`}
                  url={`https://www.jetminds.de${posts[0].url}`}
                >
                  <LinkedinIcon round size={40} />
                </LinkedinShareButton>
                <WhatsappShareButton
                  title={`${
                    posts[0].title
                  }${"\n\n"}Ich habe diesen Artikel bei JetMinds gefunden. Wie findest Du das?`}
                  separator={"\n\n"}
                  url={`https://www.jetminds.de${posts[0].url}`}
                  style={{ padding: 3 }}
                >
                  <WhatsappIcon round size={40} />
                </WhatsappShareButton>
                <TelegramShareButton
                  title={`${
                    posts[0].title
                  }${"\n\n"}Ich habe diesen Artikel bei JetMinds gefunden. Wie findest Du das?`}
                  url={`https://www.jetminds.de${posts[0].url}`}
                  style={{ padding: 3 }}
                >
                  <TelegramIcon round size={40} />
                </TelegramShareButton>
                <EmailShareButton
                  subject={`${posts[0].title}`}
                  body={`Ich habe diesen Artikel bei JetMinds gefunden. Wie findest Du das? ${"\n"} ${
                    posts[0].siteDescription
                  } ${"\n\n"}Hier geht es zum Artikel:`}
                  separator={"\n"}
                  url={`https://www.jetminds.de${posts[0].url}`}
                  style={{ padding: 3 }}
                >
                  <EmailIcon round size={40} />
                </EmailShareButton>
              </div>
            ) : null}
            <div className="col s12 m12">
              <h5 style={{ marginTop: "100px" }}>Lesen Sie auch:</h5>
              {renderReadMore(allPosts)}
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className="row">
              <div className="col s12 m8">
                {loaded && posts.length === 0 && allLoaded ? (
                  <Redirect to="/blog" />
                ) : (
                  renderPost(posts[0], props.isMobile, props.setVariables)
                )}
              </div>
              <div className="col s12 m3 offset-m1">
                <h5 style={{ marginTop: "100px" }}>Lesen Sie auch:</h5>
                {renderReadMore(allPosts)}
              </div>
            </div>
            <div className="row center">
              <div className="col s12 m12">
                <h5>Artikel teilen</h5>
              </div>
              {posts[0] ? (
                <div className="col s12 m12 center">
                  <FacebookShareButton
                    quote={`${posts[0].title}${"\n"}${
                      posts[0].siteDescription
                    }`}
                    url={`https://www.jetminds.de${posts[0].url}`}
                    style={{ padding: 3 }}
                  >
                    <FacebookIcon round size={40} />
                  </FacebookShareButton>
                  <TwitterShareButton
                    title={`${posts[0].title}${"\n"}${
                      posts[0].siteDescription
                    }${"\n"}`}
                    via="JetMinds_de"
                    related={["JetMinds_de"]}
                    style={{ padding: 3 }}
                    url={`https://www.jetminds.de${posts[0].url}`}
                  >
                    <TwitterIcon round size={40} />
                  </TwitterShareButton>
                  <LinkedinShareButton
                    title={`${posts[0].title}`}
                    summary={`${posts[0].siteDescription}`}
                    style={{ padding: 3 }}
                    source={`https://www.jetminds.de${posts[0].url}`}
                    url={`https://www.jetminds.de${posts[0].url}`}
                  >
                    <LinkedinIcon round size={40} />
                  </LinkedinShareButton>
                  <WhatsappShareButton
                    title={`${
                      posts[0].title
                    }${"\n\n"}Ich habe diesen Artikel bei JetMinds gefunden. Wie findest Du das?`}
                    separator={"\n\n"}
                    url={`https://www.jetminds.de${posts[0].url}`}
                    style={{ padding: 3 }}
                  >
                    <WhatsappIcon round size={40} />
                  </WhatsappShareButton>
                  <TelegramShareButton
                    title={`${
                      posts[0].title
                    }${"\n\n"}Ich habe diesen Artikel bei JetMinds gefunden. Wie findest Du das?`}
                    url={`https://www.jetminds.de${posts[0].url}`}
                    style={{ padding: 3 }}
                  >
                    <TelegramIcon round size={40} />
                  </TelegramShareButton>
                  <EmailShareButton
                    subject={`${posts[0].title}`}
                    body={`Ich habe diesen Artikel bei JetMinds gefunden. Wie findest Du das? ${"\n"} ${
                      posts[0].siteDescription
                    } ${"\n\n"}Hier geht es zum Artikel:`}
                    separator={"\n"}
                    url={`https://www.jetminds.de${posts[0].url}`}
                    style={{ padding: 3 }}
                  >
                    <EmailIcon round size={40} />
                  </EmailShareButton>
                </div>
              ) : null}
              <div className="col s2 m2"></div>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default GetPosts;



// WEBPACK FOOTER //
// ./src/components/services/post.js